import React, { useEffect, useMemo, useRef } from 'react';
import { arrayOf, bool, func, node, number, object, oneOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldCustomSelect } from '..';
import css from './FieldCalendlyMeet.module.css';
import { languageSelectOptions } from '../../marketplace-custom-config';
import { oneOfType } from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as validators from '../../util/validators';

const customLabel = Object.values(languageSelectOptions).reduce((pre, curnt) => {
  pre[curnt.value] = string.isRequired;
  return pre;
}, {});

const calendlyUrl = process.env.REACT_APP_CALENDLY_URL;

const nativeLangOptions = Object.keys(customLabel);

const FieldCalendlyMeetComponent = props => {
  const {
    rootClassName,
    className,
    errorClassName,
    id,
    onChange,
    userNativeLang,
    intl,
    name,
    titleClassName,
    initCalendly,
    inviteeDetails,
  } = props;

  const { name: inviteeName, email: inviteeEmail } = inviteeDetails || {};
  const calendlyOrigin = calendlyUrl ? new URL(calendlyUrl).origin : null;
  const isCalendlyEvent = e => {
    return e.origin === calendlyOrigin && e.data && e.data.length > 0;
  };

  const handleMessagEvent = e => {
    if (isCalendlyEvent(e)) {
      if (e.data.includes('msgsndr-booking-complete')) {
        const eventUri = calendlyUrl;
        if (typeof onChange === 'function') {
          onChange({ eventUri, inviteeUri: eventUri, isConfirmed: true });
        }
      }
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('message', handleMessagEvent);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('message', handleMessagEvent);
      }
    };
  }, []);

  useEffect(() => {
    if (initCalendly) {
      if (calendlyUrl && typeof window !== 'undefined' && typeof window.Calendly !== 'undefined') {
        const prefill = {
          ...(inviteeEmail ? { email: inviteeEmail } : {}),
          ...(inviteeName ? { name: inviteeName } : {}),
        };
        window.Calendly.initPopupWidget({
          url: calendlyUrl,
          prefill,
          utm: {},
        });
      }
    }
  }, [initCalendly, inviteeName, inviteeEmail]);

  return null;
};

FieldCalendlyMeetComponent.defaultProps = {
  rootClassName: null,
  className: null,
  errorClassName: null,
  id: null,
  userNativeLang: languageSelectOptions.en.value,
};

FieldCalendlyMeetComponent.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,
  titleClassName: string,
  // the label can reference the input in the `for` attribute
  id: string,
  name: string.isRequired,
  userNativeLang: oneOf(nativeLangOptions).isRequired,
};

const FieldCalendlyMeetComp = injectIntl(FieldCalendlyMeetComponent);

const FieldCalendlyMeet = props => {
  return <FieldCalendlyMeetComp {...props} />;
};

FieldCalendlyMeet.defaultProps = {
  rootClassName: null,
  className: null,
  errorClassName: null,
  titleClassName: null,
  userNativeLang: languageSelectOptions.en.value,
  initCalendly: false,
};

FieldCalendlyMeet.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,
  titleClassName: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string.isRequired,
  name: string.isRequired,
  userNativeLang: oneOf(nativeLangOptions).isRequired,
  initCalendly: bool.isRequired,
  inviteeDetails: shape({ name: string, email: string }).isRequired,
  onChange: func.isRequired,
};

export default FieldCalendlyMeet;
